import { SecurityRole } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { PltUser } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { UserDetailsFormValues } from "./UserDetailsForm.types";

export const getUserDtoPayload = (options: {
  user: PltUser;
  values: UserDetailsFormValues;
  securityRoles: SecurityRole[];
}): PltUser => {
  const { user, securityRoles, values } = options;
  return {
    ...user,
    firstName: values.firstName,
    lastName: values.lastName,
    status: values.status,
    isInactive: values.isInactive,
    businessRoles: values.businessRoles ?? [],
    roles: [],
    securityRoles: values.securityRoles.map(code => {
      return {
        code,
        securityRoleId: securityRoles.find(role => role.code === code)?.id
      };
    })
  };
};
